import { createApi } from '@reduxjs/toolkit/query/react'
import { API } from 'src/utils/amplify/legacy'

const restBaseQuery =
	() =>
	async ({
		apiName,
		path,
		method,
		myInit = {
			headers: {},
		},
	}: {
		apiName: 'restApiChedar' | 'subscriptionApi'
		path: string
		method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DEL' | 'HEAD'
		myInit?: any
	}) => {
		try {
			let responseData
			if (method === 'POST') {
				responseData = await API.post(apiName, path, myInit)
			} else {
				responseData = await API.get(apiName, path, myInit)
			}

			return { data: responseData as any }
		} catch (error) {
			return { error }
		}
	}

export const restApi = createApi({
	reducerPath: 'restApi',
	baseQuery: restBaseQuery(),
	// Re-fetches once cache has been stale for 120 secs
	keepUnusedDataFor: 120,
	tagTypes: ['PublicQuote', 'Subscription', 'Chat'],
	endpoints: () => ({}),
})
